import { Box, Button, Container, Grid, Sheet, Stack, Typography, useTheme } from '@mui/joy';
import {
    AppStoreLogo,
    ArrowLineDownIcon,
    GooglePlayLogo
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

function PhonesMockup() {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: { xs: 320, md: 400 },
                mx: { xs: 'auto', md: 0 },
                ml: { md: 'auto' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
            }}
        >
            <Box
                component="img"
                src="/img/welcome/iphone.png"
                alt="Аквариум на iPhone"
                sx={{
                    width: '56%',
                    height: 'auto',
                    position: 'relative',
                    zIndex: 2,
                }}
            />
            <Box
                component="img"
                src="/img/welcome/android.png"
                alt="Аквариум на Android"
                sx={{
                    width: '50%',
                    height: 'auto',
                    ml: '-21%',
                    mb: '6%',
                    position: 'relative',
                    zIndex: 1,
                }}
            />
        </Box>
    );
}

export function DownloadSection() {
    const theme = useTheme();
    const isDark = theme.colorSchemes?.dark && theme.palette.mode === 'dark';

    return (
        <Container maxWidth="lg" id="download">
            <FadeIn y={40}>
                <Sheet
                    variant="soft"
                    sx={{
                        my: { md: 12, xs: 6 },
                        p: { xs: 4, md: 8 },
                        borderRadius: '32px',
                        backgroundColor: 'rgba(72, 190, 186, 0.06)',
                    }}
                >
                    <Grid container spacing={6} alignItems="center">
                        <Grid xs={12} md={6}>
                            <Typography
                                level="h2"
                                sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                            >
                                Аквариум всегда<br />под рукой
                            </Typography>
                            <Typography level="body-lg" sx={{ color: 'text.secondary', mb: 4 }}>
                                Скачайте приложение для iOS или Android — и ваша лента,
                                чаты и звонки будут с вами в кармане.
                            </Typography>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Button
                                    size="lg"
                                    component="a"
                                    href="/apps"
                                    sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                                >
                                    Скачать приложение
                                </Button>
                                {/* <Button
                                    size="lg"
                                    component="a"
                                    href="#"
                                    startDecorator={<GooglePlayLogo size={24} />}
                                    sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                                >
                                    Google Play
                                </Button> */}
                            </Stack>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <PhonesMockup />
                        </Grid>
                    </Grid>
                </Sheet>
            </FadeIn>
        </Container>
    );
}
